import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useCallback, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const SubscriptionItemForm = forwardRef(({subscription, item, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={item}
      type="item"
      fieldsComponent={useCallback(props => <Fields {...props} subscription={subscription}/>, [subscription])}
      onSave={(update) => services.subscription.saveSubscriptionItem(subscription, update)}
      onSaved={onSaved}
    />
  );
});

export default SubscriptionItemForm;
